import { Field, reduxForm, SubmissionError } from "redux-form";
import { Button, Input } from "expano-components";

import { Main, Dashboard } from "components";

import useCreate from "hooks/useCreate";

import { ReactComponent as ProductIcon } from "icons/product.svg";

const InputField = (props) => <Input {...props} />;

const ProducerNew = ({ handleSubmit, pristine, history, invalid }) => {
  const { is_creating, create } = useCreate({
    path: "/producers",
    onSuccess: ({ id }) => {
      history.push(`/producers/${id}`);
    },
    onError: (err) => {
      throw new SubmissionError(
        Object.fromEntries(
          Object.entries(err).map(([key, value]) => {
            if (["producer", "brand", "root_taxon"].includes(key)) {
              return [`${key}_id`, value];
            }
            return [key, value];
          })
        )
      );
    },
  });

  const onSubmit = (values) => create(values);

  return (
    <Main
      page={{
        name: "Dodaj producenta",
        icon: <ProductIcon />,
        breadcrumbs: [
          {
            name: "Producenci",
            path: "/producers",
          },
          { name: "Dodaj producenta" },
        ],
      }}
    >
      <div className="dashboard-wrapper-flex">
        <div className="column-half">
          <Dashboard
            header={{ title: "Podstawowe informacje", icon: "info" }}
            footer={
              <>
                <Button
                  type="cancel"
                  onClick={() => history.push("/producers")}
                />
                <Button
                  type="save"
                  text={is_creating ? "Proszę czekać..." : "Utwórz"}
                  disabled={pristine || invalid || is_creating}
                  onClick={handleSubmit(onSubmit)}
                />
              </>
            }
          >
            <form
              className="dashboard__form"
              onSubmit={handleSubmit(onSubmit)}
              noValidate
            >
              <Field
                name="name"
                label="Nazwa"
                component={InputField}
                type="text"
              />
            </form>
          </Dashboard>
        </div>
      </div>
    </Main>
  );
};

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Nazwa produktu jest wymagana!";
  }

  return errors;
};

export default reduxForm({
  form: "create-producer",
  enableReinitialize: true,
  validate,
})(ProducerNew);
